import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import PurchaseServices from "./PurchaseServices";

const initialState = {
  purchase: null,
  isError: false,
  isSuccess: false,
  isSuccessCreatePurchase: false,
  isSuccessAddPurchase: false,
  isLoading: false,
  purchases: [],
  message: "",
};

export const getPurchases = createAsyncThunk(
  "purchase/getPurchases",
  async (_, thunkAPI) => {
    try {
      return await PurchaseServices.getPurchases();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getPurchaseById = createAsyncThunk(
  "purchase/getPurchaseById",
  async (id, thunkAPI) => {
    try {
      return await PurchaseServices.getPurchaseById(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const createPurchase = createAsyncThunk(
  "purchase/createPurchase",
  async (purchaseData, thunkAPI) => {
    try {
      return await PurchaseServices.createPurchase(purchaseData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const addRemovePurchase = createAsyncThunk(
  "purchase/addRemovePurchase",
  async ({ purchaseData, id }, thunkAPI) => {
    try {
      return await PurchaseServices.addRemovePurchase({ purchaseData, id });
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const updatePurchase = createAsyncThunk(
  "purchase/updatePurchase",
  async ({ purchaseData, id }, thunkAPI) => {
    try {
      return await PurchaseServices.updatePurchase({ purchaseData, id });
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const deletePurchase = createAsyncThunk(
  "purchase/deletePurchase",
  async (purchaseId, thunkAPI) => {
    try {
      return await PurchaseServices.deletePurchase(purchaseId);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const purchaseSlice = createSlice({
  name: "purchase",
  initialState,
  reducers: {
    RESET_PURCHASE(state) {
      state.isError = false;
      state.isSuccess = false;
      state.isSuccessAddPurchase = false;
      state.isLoading = false;
      state.isSuccessCreatePurchase = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(getPurchases.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(getPurchases.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.purchases = action.payload.data;
      })

      .addCase(getPurchases.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      })

      .addCase(getPurchaseById.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(getPurchaseById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.purchase = action.payload.data;
      })

      .addCase(getPurchaseById.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      })

      .addCase(createPurchase.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(createPurchase.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccessCreatePurchase = true;
        state.purchase = action.payload.data;
        toast.success(action.payload.message);
      })

      .addCase(createPurchase.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      })

      .addCase(addRemovePurchase.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(addRemovePurchase.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccessCreatePurchase = true;
        state.purchase = action.payload.data;
        toast.success(action.payload.message);
      })

      .addCase(addRemovePurchase.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      })

      .addCase(updatePurchase.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(updatePurchase.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccessAddPurchase = true;
        state.purchase = action.payload.data;
        toast.success(action.payload.message);
      })

      .addCase(updatePurchase.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      })

      .addCase(deletePurchase.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(deletePurchase.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        toast.success(action.payload.message);
      })

      .addCase(deletePurchase.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      });
  },
});

export const { RESET_PURCHASE } = purchaseSlice.actions;
export const selectPurchases = (state) => state.purchase.purchases;
export const selectPurchase = (state) => state.purchase.purchase;
export const selectCreatePurchaseSuccess = (state) =>
  state.purchase.isSuccessCreatePurchase;
export const selectupdatePurchaseSuccess = (state) =>
  state.purchase.isSuccessAddPurchase;

export default purchaseSlice.reducer;
